import * as THREE from 'three';
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js';
import type { Font } from 'three/examples/jsm/loaders/FontLoader.js';

// Extruded, beveled 3D-text geometry for digits/expressions — the signature
// CountStrike look (exact legacy recipe: size 1, depth 0.5, bevel 0.03/0.02).
// Geometries are memoized per string and SHARED: never mutate, scale, or
// dispose what this returns (userData.shared marks them for disposeObject and
// ShapeShatter, which clone before mutating). Glyph triangulation is expensive,
// and any rule only produces a handful of distinct display strings.

const cache = new Map<string, THREE.BufferGeometry>();

export function createDigitGeometry(font: Font, text: string): THREE.BufferGeometry {
  let geo = cache.get(text);
  if (geo) return geo;
  geo = new TextGeometry(text, {
    font,
    size: 1,
    depth: 0.5,
    curveSegments: 12,
    bevelEnabled: true,
    bevelThickness: 0.03,
    bevelSize: 0.02,
    bevelOffset: 0,
    bevelSegments: 3,
  });
  geo.computeBoundingBox();
  const bb = geo.boundingBox;
  // Center X and Z so Y-spin rotates about the glyph's middle; keep the
  // baseline at y=0 like the legacy meshes.
  if (bb) geo.translate(-0.5 * (bb.max.x - bb.min.x), 0, -0.5 * (bb.max.z - bb.min.z));
  geo.userData.shared = true;
  cache.set(text, geo);
  return geo;
}
